module.exports = __webpack_public_path__ + "img/branch.1d65c4b2.png";